export const URL_PATH = {
  projectDetail: 'rs/project/:projectId',
  comment: 'comment',
  workflow: 'workflow',
} as const;
